<div class="map-toolbar brightness-contrast-controller toolbar-toggle-container">
  <button
    type="button"
    matIconButton
    class="toolbar-btn"
    [class.selected]="displayPanel"
    matTooltip="{{ !displayPanel ? 'Filters' : null }}"
    (click)="togglePanelDisplay()">
    <mat-icon>photo_filter</mat-icon>
  </button>

  <div [class.d-none]="!displayPanel" class="controls-panel">
    <div class="d-flex flex-row align-items-center">
      <div class="d-flex flex-column">
        <div class="d-flex flex-row align-items-center panel-tool">
          <mat-form-field appearance="fill">
            <mat-label>Image filter</mat-label>
            <mat-select (selectionChange)="selectFilter($event)">
              <mat-option [value]="">None</mat-option>
              <mat-option *ngFor="let filter of filters" [value]="filter">
                {{ filter }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</div>
